import React, { useEffect, useState } from "react";
import { injectModels } from "../redux/injectModels";
import { Routes } from "../constants";
import { Link } from "react-router-dom";
// import { useAccount } from "wagmi";
// import Web3 from "web3";
// import * as CONTRACTS from "../contracts";
//import { routes } from "../constants/routes";
//import { toast } from "react-toastify";

function Dashboard(props) {
  // const [dataCount, setDataCount] = useState(0);
  // const [revenue, setRevenue] = useState(0);
  // const [packages, setPackages] = useState("");
  // const [tokenData, setTokenData] = useState("");

  // const BLOCKCHAIN_NETWORK = process.env.REACT_APP_BLOCKCHAIN_NETWORK;
  // const TREX_ADDRESS = process.env.REACT_APP_TREX_ADDRESS;

  // const IDENTITY_ADDRESS = process.env.REACT_APP_REGISTERY_ADDRESS;

  useEffect(() => {
    getData();
    getData2();
  }, []);

  const getData2 = async () => {
    props.application.setLoading(true);

    // try {
    //   // Initialize Web3 instance
    //   const provider = window.ethereum
    //     ? window.ethereum
    //     : new Web3.providers.HttpProvider(BLOCKCHAIN_NETWORK);
    //   const web3 = new Web3(provider);

    //   // const contract = new web3.eth.Contract(
    //   //   CONTRACTS.TREXFactory.abi,
    //   //   TREX_ADDRESS
    //   // );

    //   // Fetch the array of minted token addresses
    //   // const mintedTokenAddresses = await contract.methods
    //   //   .getMintedTokens()
    //   //   .call();
    //   // Fetch token details for each address
    //   // const tokenDetailsPromises = mintedTokenAddresses.map(async (address) => {
    //   //   const tokenContract = new web3.eth.Contract(
    //   //     CONTRACTS.Token.abi,
    //   //     address
    //   //   );
    //     // const propertyAddress = await tokenContract.methods
    //     //   .getTokenAddress()
    //     //   .call();
    //     const name = await tokenContract.methods.name().call();
    //     const primarySalePrice = await tokenContract.methods
    //       .primarySalePrice()
    //       .call();

    //     return {
    //       address,
    //       name,
    //       price: web3.utils.fromWei(primarySalePrice, "ether"), // Assuming price is in Wei, converting to Ether
    //     };
    //   });

    //   const allTokenDetails = await Promise.all(tokenDetailsPromises);

    //   // Update state with fetched token data
    //   setTokenData(allTokenDetails);

    //   props.application.setLoading(false);
    // } catch (error) {
    //   console.error("Failed to fetch token data:", error);
    //   props.application.setLoading(false);
    //   toast.error("Failed to fetch token data!");
    // }
    props.application.setLoading(false);
  };

  const getData = async () => {
    props.application.setLoading(true);
    // try {
    //   const res = await props.admin.getAllUsers();
    //   const filteredUsers = res.data.filter((user) => user.isAdmin !== true);
    //   if (filteredUsers.length > 0) {
    //     const updatedUsers = await Promise.all(
    //       filteredUsers.map(async (user) => {
    //         if (user.walletId) {
    //           try {
    //             const provider = window.ethereum
    //               ? window.ethereum
    //               : new Web3.providers.HttpProvider(BLOCKCHAIN_NETWORK);
    //             const web3 = new Web3(provider);
    //             const contract = new web3.eth.Contract(
    //               CONTRACTS.IdentityRegistry.abi,
    //               IDENTITY_ADDRESS
    //             );
    //             // Fetch the verified status from the contract
    //             const isVerifiedOnChain = await contract.methods
    //               .isVerified(user.walletId)
    //               .call();
    //             // Add the verification status to the user object for UI purposes
    //             return { ...user, isVerified: isVerifiedOnChain };
    //           } catch (error) {
    //             console.error(
    //               `Error verifying wallet ${user.walletId}:`,
    //               error
    //             );
    //             toast.dismiss();
    //             toast.error("Error verifying wallet address!");
    //             return { ...user, isVerified: false }; // Default to not verified on error
    //           }
    //         } else {
    //           return { ...user, isVerified: false }; // Default to not verified if no walletId
    //         }
    //       })
    //     );
    //     //  console.log(data.length(),"dsafaaaaaa")
    //     setDataCount(updatedUsers);
    //   }
    //   props.application.setLoading(false);
    // } catch (error) {
    //   props.application.setLoading(false);
    //   console.error("Error fetching users:", error);
    // }
    props.application.setLoading(false);
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
            <h4 className="mb-sm-0">Admin</h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to={Routes.ADMIN_DASHBOARD}>Dashboard</Link>
                </li>
                {/* <li className="breadcrumb-item active">Admin</li> */}
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="row">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-xxl-3 col-md-6 ">
              <Link to={Routes.ADMIN_EVENTS}>
                <div className="card info-card sales-card card-pointer brdr-c hgty">
                  <div className="card-body">
                    <h5 className="card-title">
                      Users <span>| Total</span>
                    </h5>
                    <div className="d-flex align-items-center">
                      <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                        <i className="fa-solid fa-user-group" />
                      </div>
                      <div className="ps-3">
                        <h6>{dataCount.length}</h6>
                      </div>
                    </div>
                     <p className="hour mt-2">Last 24 hours</p> 
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-xxl-3 col-md-6 ">
              <Link to={routes.PROPERTIES}>
                <div className="card info-card customers-card card-pointer brdr-c hgty">
                  <div className="card-body">
                    <h5 className="card-title">
                      properties <span>| Total</span>
                    </h5>
                    <div className="d-flex align-items-center">
                      <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                        <i className="fa-solid fa-user-group" /> 
                        <i className="fa-solid fa-dollar-sign" />
                      </div>
                      <div className="ps-3">
                        <h6>{tokenData.length}</h6>
                        <span className="text-danger small pt-1 fw-bold">12%</span> <span className="text-muted small pt-2 ps-1">decrease</span> 
                      </div>
                    </div>
                     <p className="hour mt-2">Last 24 hours</p> 
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xxl-3 col-md-6">
          <div className="card">
            <div className="card-header align-items-center d-flex">
              <h4 className="card-title mb-0 flex-grow-1">Sales Forecast</h4>
              <div className="flex-shrink-0">
                <div className="dropdown card-header-dropdown">
                  <a
                    className="text-reset dropdown-btn"
                    href="#"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span className="fw-semibold text-uppercase fs-12">
                      Sort by:{" "}
                    </span>
                    <span className="text-muted">
                      Nov 2021<i className="mdi mdi-chevron-down ms-1"></i>
                    </span>
                  </a>
                  <div className="dropdown-menu dropdown-menu-end">
                    <a className="dropdown-item" href="#">
                      Oct 2021
                    </a>
                    <a className="dropdown-item" href="#">
                      Nov 2021
                    </a>
                    <a className="dropdown-item" href="#">
                      Dec 2021
                    </a>
                    <a className="dropdown-item" href="#">
                      Jan 2022
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body pb-0">
              <div
                id="sales-forecast-chart"
                data-colors='["--vz-primary", "--vz-success", "--vz-warning"]'
                data-colors-minimal='["--vz-primary-rgb, 0.75", "--vz-primary", "--vz-primary-rgb, 0.55"]'
                data-colors-creative='["--vz-primary", "--vz-secondary", "--vz-info"]'
                data-colors-corporate='["--vz-primary", "--vz-success", "--vz-secondary"]'
                data-colors-galaxy='["--vz-primary", "--vz-secondary", "--vz-info"]'
                data-colors-classic='["--vz-primary", "--vz-warning", "--vz-secondary"]'
                className="apex-charts"
                dir="ltr"
              ></div>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-md-6">
          <div className="card card-height-100">
            <div className="card-header align-items-center d-flex">
              <h4 className="card-title mb-0 flex-grow-1">Deal Type</h4>
              <div className="flex-shrink-0">
                <div className="dropdown card-header-dropdown">
                  <a
                    className="text-reset dropdown-btn"
                    href="#"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span className="fw-semibold text-uppercase fs-12">
                      Sort by:{" "}
                    </span>
                    <span className="text-muted">
                      Monthly<i className="mdi mdi-chevron-down ms-1"></i>
                    </span>
                  </a>
                  <div className="dropdown-menu dropdown-menu-end">
                    <a className="dropdown-item" href="#">
                      Today
                    </a>
                    <a className="dropdown-item" href="#">
                      Weekly
                    </a>
                    <a className="dropdown-item" href="#">
                      Monthly
                    </a>
                    <a className="dropdown-item" href="#">
                      Yearly
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body pb-0">
              <div
                id="deal-type-charts"
                data-colors='["--vz-warning", "--vz-danger", "--vz-success"]'
                data-colors-minimal='["--vz-primary-rgb, 0.15", "--vz-primary-rgb, 0.35", "--vz-primary-rgb, 0.45"]'
                data-colors-modern='["--vz-warning", "--vz-secondary", "--vz-success"]'
                data-colors-interactive='["--vz-warning", "--vz-info", "--vz-primary"]'
                data-colors-corporate='["--vz-secondary", "--vz-info", "--vz-success"]'
                data-colors-classic='["--vz-secondary", "--vz-danger", "--vz-success"]'
                className="apex-charts"
                dir="ltr"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-4"></div>
      </div> */}
    </React.Fragment>
  );
}

export default injectModels(["admin", "application"])(Dashboard);
